module.exports = __webpack_public_path__ + "static/audiens2-83a045b7008b18b4eed6da1be3b992ef.png";